export default __webpack_public_path__ + "static/media/watering_can.7c9d6e63.jpg";